import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "kn-list--column p-col-4 p-sm-4 p-md-3 p-p-0" }
const _hoisted_4 = {
  class: "kn-list-item",
  "data-test": "list-item"
}
const _hoisted_5 = { class: "kn-list-item-text" }
const _hoisted_6 = { class: "kn-list-item-text-secondary" }
const _hoisted_7 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_router_view = _resolveComponent("router-view")
  const _component_KnHint = _resolveComponent("KnHint")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.tenantManagement.title')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_FabButton, {
              icon: "fas fa-plus",
              "data-test": "open-form-button",
              onClick: _ctx.showForm
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Listbox, {
              key: 1,
              class: "kn-list--column",
              options: _ctx.multitenants,
              filter: true,
              "filter-placeholder": _ctx.$t('common.search'),
              "option-label": "name",
              "filter-match-mode": "contains",
              "filter-fields": _ctx.tenantsDescriptor.filterFields,
              "empty-filter-message": _ctx.$t('common.info.noDataFound'),
              "data-test": "tenants-list",
              onChange: _ctx.showForm
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              option: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("span", null, _toDisplayString(slotProps.option.TENANT_NAME), 1),
                    _createVNode("span", _hoisted_6, _toDisplayString(slotProps.option.TENANT_THEME), 1)
                  ]),
                  _createVNode(_component_Button, {
                    icon: "far fa-trash-alt",
                    class: "p-button-text p-button-rounded p-button-plain",
                    "data-test": "delete-button",
                    onClick: _withModifiers(($event: any) => (_ctx.deleteTenantConfirm(slotProps.option)), ["stop"])
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["options", "filter-placeholder", "filter-fields", "empty-filter-message", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_router_view, {
          "selected-tenant": _ctx.selTenant,
          licenses: _ctx.listOfavailableLicenses,
          onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.touched = true)),
          onClosed: _ctx.onFormClose,
          onInserted: _ctx.pageReload
        }, null, 8, ["selected-tenant", "licenses", "onClosed", "onInserted"]),
        (_ctx.hintVisible)
          ? (_openBlock(), _createBlock(_component_KnHint, {
              key: 0,
              title: 'managers.tenantManagement.hintTitle',
              hint: 'managers.tenantManagement.hint'
            }, null, 8, ["title", "hint"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}